import { useColorScheme } from "@mui/material/styles";

type ColorMode = "light" | "dark" | "system";

interface ThemeModeResult {
  mode: ColorMode | undefined;
  resolvedMode: "light" | "dark" | undefined;
  isDarkMode: boolean;
  setMode: (mode: ColorMode) => void;
  toggleThemeMode: () => void;
}

const useThemeMode = (): ThemeModeResult => {
  const { mode, setMode, systemMode } = useColorScheme();

  // With `defaultMode="system"` the mode stays "system" until the user picks
  // one, so the device preference from `systemMode` is what's actually applied.
  const resolvedMode = mode === "system" ? systemMode : mode;
  const isDarkMode = resolvedMode === "dark";

  const toggleThemeMode = () => {
    const nextMode = isDarkMode ? "light" : "dark";
    setMode(nextMode);
  };

  return { mode, resolvedMode, isDarkMode, setMode, toggleThemeMode };
};

export default useThemeMode;
